import MerchantInvoices from "../symbols/getMerchantInvoices";

interface MerchantInvoiceResponseModelList {
  OrderId: string;
  OrderNo: number;
  InvoiceNo: string;
  FileUrl: string;
  OrderDate: Date;
  InvoiceDate: Date;
};

export interface MerchantInvoiceGroupResponseModel {
  OrderNo: number;
  Invoices: MerchantInvoiceResponseModelList[];
};
export interface MerchantInvoiceListResponseModel {
  InvoiceGroups: MerchantInvoiceGroupResponseModel[];
  Page: number;
  Size: number;
  Total: number;
}
interface State {
  data: MerchantInvoiceListResponseModel;
  loading: boolean;
  error: any;
}
const initialState: State = {
  data: { InvoiceGroups: [], Page: 0, Size: 0, Total: 0 },
  loading: false,
  error: false,
};

function MerchantInvoicesReducer(state: State = initialState, action: any) {
  switch (action.type) {
    case MerchantInvoices.MERCHANT_INVOICES:
      return { ...state, loading: true, error: false };
    case MerchantInvoices.MERCHANT_INVOICES_SUCCESS:
      return {
        ...state,
        data: action.payload.Result as MerchantInvoiceListResponseModel,
        loading: false,
        error: false,
      };
    case MerchantInvoices.MERCHANT_INVOICES_FAILURE:
      return {
        ...state,
        data: [],
        loading: false,
        error: true,
      };
    case MerchantInvoices.CLEAR_MERCHANT_INVOICES:
      return {
        ...state,
        data: [],
        loading: false,
        error: false,
      };

    default:
      return state;
  }
}
export default MerchantInvoicesReducer;
